export default __webpack_public_path__ + "static/media/3_Intro.b2d7f734.mp4";